import React from 'react';
// import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import HttpService from "./services/HttpService";
import UserService from "./services/UserService";
import LanguageWrapper from './components/languageWrapper/LanguageWrapper';
import {createRoot} from 'react-dom/client';

const rootElement:any = document.getElementById('root');
const root:any = createRoot(rootElement);

const renderApp = () => {
  root.render(
    // <React.StrictMode>
    // </React.StrictMode>
      <LanguageWrapper>
        <App />
      </LanguageWrapper>
  );
};

UserService.initKeycloak(renderApp);
HttpService.configure();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

